import type {IApontamentoEntidadeEvent} from "@/domain/events/apontamentoEntidade.event";

import type {GrupoPermissaoVm} from "@/domain/type/grupoPermissao.type";
import type {CargoVm, EmpresaColaboradorCargoVm} from "@/domain/type/usuario.type";
import type {EnderecoVm} from "@/domain/type/endereco.type";
import type {SeguroVm} from "@/domain/type/seguro.type";
import {
    EVendaProdutoTipo,
    type SelecaoVendaPagamentoVm,
    type SelecaoVendaProdutoVm,
} from "@/domain/type/venda.type";
import type {MetaVendaColaboradorVm} from "@/domain/type/metaVendaColaborador.type";
import type {FormaPagamentoTarifaAgrupadaVm} from "@/domain/type/formaPagamento.type";
import type {EAutorizacaoAcaoTipo, InfoAutorizacaoDesconto} from "@/domain/type/autorizacao.type";


//Enumeradores com os modais
export enum EModalId {

    modalEmptyComponent = "modalEmptyComponent",
    modalExportTableSelectColumns = "modalExportTableSelectColumns",

    modalApontamentoLista = "modalApontamentoLista",
    modalApontamentoCadastro = "modalApontamentoCadastro",

    modalUsuarioColaboradorCadastro = "modalUsuarioColaboradorCadastro",
    modalColaboradorEmpresa = "modalColaboradorEmpresa",
    modalColaboradorEmpresaAdicionar = "modalColaboradorEmpresaAdicionar",
    modalEmpresasDoColaborador = "modalEmpresasDoColaborador",
    modalGrupoPermissaoCadastro = "modalGrupoPermissaoCadastro",

    modalEmpresaCadastro = "modalEmpresaCadsatro",
    modalEmpresaAlteracao = "modalEmpresaAlteracao",

    modalClienteCadastro = "modalClienteCadastro",
    modalClienteAlteracao = "modalClienteAlteracao",

    modalItemClienteLista = "modalItemClienteLista",
    modalItemClienteCadastro = "modalItemClienteCadastro",
  
    
    modalClienteEndereco = "modalClienteEndereco",

    modalEnderecoCadastro = "modalEnderecoCadastro",

    modalPlanoSeguroCadastro = "modalPlanoSeguroCadastro",
    modalPlanoSeguroAlteracao = "modalPlanoSeguroAlteracao",

    modalSeguroCadastro = "modalSeguroCadastro",

    modalSinistroCadastro = "modalSinistroCadastro",

    modalLancamentoCadastro = "modalLancamentoCadastro",
    modalLancamentoAlteracao = "modalLancamentoAlteracao",
    modalLancamentoPago = "modalLancamentoPago",

    modalSelecaoProdutoVenda = "modalSelecaoProdutoVenda",
    modalSelecaoPagamentoVenda = "modalSelecaoPagamentoVenda",
    modalSelecaoPlanoSeguroVenda = "modalSelecaoPlanoSeguroVenda",
    modalVendaProdutoLista = "modalVendaProdutoLista",
    modalVendaPagamentoLista = "modalVendaPagamentoLista",

    modalVendaCadastro = "modalVendaCadastro",

    modalComissaoCadastro = "modalComissaoCadastro",
    modalComissaoAlteracao = "modalComissaoAlteracao",

    modalMetaVendaCadastro = "modalMetaVendaCadastro",
    modalMetaVendaAlteracao = "modalMetaVendaAlteracao",
    modalMetaVendaColaboradorCadastro = "modalMetaVendaColaboradorCadastro",

    modalEmpresaDescontoCadastro = "modalEmpresaDescontoCadastro",
    modalEmpresaDescontoAlteracao = "modalEmpresaDescontoAlteracao",

    modalFormaPagamentoTarifaCadastro = "modalFormaPagamentoTarifaCadastro",
    modalFormaPagamentoTarifaImporta = "modalFormaPagamentoTarifaImporta",

    modalAutorizacaoCodigo = "modalAutorizacaoCodigo",


    modalEmpresaDescontoColaboradorCadastro = "modalEmpresaDescontoColaboradorCadastro",
}

//Tipos de parametros dos modais


//Modal Apontamento Cadastro
export interface ModalApontamentoCadastro {
    entidadeService?: any,
    codigoEntidade?: string,
    apontamentoEvent?: IApontamentoEntidadeEvent,
}

//Modal Apontamento Lista
export interface ModalApontamentoLista {
    entidadeService?: any,
    codigoEntidade?: string,
    apontamentoEvent?: IApontamentoEntidadeEvent,
}

export interface ModalCadastroEmpresa {
    propCodigoEmpresa?: string
    propCgpe?: string
}

export interface ModalEmpresaAlteracao {
    propCodigoEmpresa?: string
    propCgpe?: string
}

//modal cadastro do contato
export interface ModalContatoCadastro {
    propCodigoContato?: number,
    propCodigoEmpresa?: number,
    propIsModalAlteracao?: boolean
}

export interface ModalEmptyComponent {
    content?: string,
}


export interface ModalExportTableSelectColumns {
    propColunas: any
}

export interface ModalUsuarioColaboradorCadastro {
    propCodigoUsuarioColaborador?: string
    propCgpe?: string
    propIsModalAlteracao?: boolean
}

export interface ModalColaboradorEmpresa {
    propEmpresaId?: string
    propCgpe?: string
}

export interface ModalColaboradorEmpresaAdicionar {
    propEmpresaId?: string
    propCgpe?: string
}

export interface ModalEmpresasDoColaborador {
    propCgpe?: string,
    propColaboradorPublicId?: string,
    propListaEmpresas?: EmpresaColaboradorCargoVm[]
}

export interface ModalGrupoPermissaoCadastro {
    propCgpe: string,
    propCodigoGrupoPermissao?: number,
    propGrupoPermissao?: GrupoPermissaoVm,
    propIsVisualizacao?: boolean
}

export interface ModalClienteCadastro {
    propClienteId?: string,
    propCgpe?: string,
    propEmpresaId?: string
}

export interface ModalClienteAlteracao {
    propClienteId?: string,
    propCgpe?: string,
}

export interface ModalEnderecoCadastro {
    propEndereco?: EnderecoVm
    propExibeBotao?: boolean
}

export interface ModalClienteEndereco {
    propClienteId?: string
}

export interface ModalPlanoSeguroCadastro {
    propPlanoSeguroId?: string,
    propCgpe?: string,
}

export interface ModalPlanoSeguroAlteracao {
    propPlanoSeguroId?: string,
    propCgpe?: string,
}

export interface ModalSeguroCadastro {
    propSeguroId?: string,
}

export interface ModalSinistroCadastro {
    propSeguro?: SeguroVm,
    propSinistroId?: string,
}

export interface ModalLancamentoCadastro {
    propLancamentoId?: string,
    propCgpe?: string,
}

export interface ModalLancamentoAlteracao {
    propLancamentoId?: string,
    propCgpe?: string,
}

export interface ModalLancamentoPago {
    propCgpe?: string,
    propEmpresaId?: string,
    propLancamentoId?: string,
    propValor?: number
}

export interface ModalSelecaoProdutoVenda {
    propProduto: SelecaoVendaProdutoVm | undefined
    propIsAlteracao: boolean
}

export interface ModalSelecaoPagamentoVenda {
    propPagamento: SelecaoVendaPagamentoVm | undefined
    propIsAlteracao: boolean
    propValorAPagar: number
}

export interface ModalSelecaoPlanoSeguroVenda {
    propProdutoVenda: SelecaoVendaProdutoVm | undefined
    propClienteId: string
    propColaboradorPublicId: string,
    propEmpresaId: string

}

export interface ModalVendaPagamentoLista {

}

export interface ModalVendaPagamentoLista {
    propVendaId: string,
}

export interface ModalVendaProdutoLista {
    propVendaId: string,
    propIsSelecaoAtiva?: boolean,
    propTipoProduto?: EVendaProdutoTipo
}

export interface ModalVendaCadastro {
    propVendaId?: string
}

export interface ModalComissaoCadastro {
    propComissaoId: string,
    propEmpresaId: string,
    propEmpresaNome: string
    propAlteracao?: boolean
}

export interface ModalComissaoAlteracao {
    propComissaoId?: string,
    propEmpresaId?: string,
    propColaboradorId?: string,
}

export interface ModalMetaVendaCadastro {
    propMetaVendaId?: string,
    propEmpresaId?: string,
    propCgpe?: string,
}

export interface ModalMetaVendaAlteracao {
    propMetaVendaId?: string,
    propEmpresaId?: string,
    propColaboradorId?: string,
}

export interface ModalMetaVendaColaboradorCadastro {
    propMetaVendaId?: string,
    propEmpresaId?: string,
    propCgpe?: string,
    propMetasColaboradores?: MetaVendaColaboradorVm[]
}


export interface ModalEmpresaDescontoCadastro {
    propEmpresaDescontoId?: string,
    propEmpresaId?: string,
    propPolitica?: number,
    propCgpe?: string,
    propCargo?: CargoVm,
    propVisualizacao?: boolean
}

export interface ModalEmpresaDescontoAlteracao {
    propCgpe?: string,
    propEmpresaDescontoId?: string,
    propEmpresaId?: string,
    propColaboradorId?: string,
}

export interface ModalFormaPagamentoTarifaCadastro {
    propFormaPagamentoId?: string,
    propValorTarifa?: number[],
    propEmpresaId?: string,
    propEmpresaNome?: string
    propCgpe?: string,
    propFormaPagamentoTarifaVm?: FormaPagamentoTarifaAgrupadaVm,
    propAlteracao?: boolean
}

export interface ModalFormaPagamentoTarifaImporta {
    propFormaPagamentoId?: string,
    propEmpresaId?: string,
    propCgpe?: string,
}

export interface ModalAutorizacaoCodigo {
    propTipoAutorizacao: EAutorizacaoAcaoTipo,
    propEmpresaId: string,
    propInfoAutorizacaoDesconto?: InfoAutorizacaoDesconto,

}

export interface ModalEmpresaDescontoColaboradorCadastro {
    propEmpresaDescontoColaboradorId?: number,
    propEmpresaId?: string,
    propEmpresaNome?: string
    propCgpe?: string,
}

export interface ModalItemClienteLista {
    propClienteId?: string,
    // propCgpe?: string
}

export interface ModalItemClienteCadastro {
    propItemClienteId?: string,
    propClienteId?: string,
    propCgpe?: string,
}

// export interface ModalItemClienteAlteracao {
//     propItemClienteId?: string,
//     propClienteId?: string,
//     propCgpe?: string,
// }